<template>
  <div>
    <v-btn v-bind="$attrs" color="primary" :href="url">+ Bookmark.Exp</v-btn>
    <v-btn ref="copy" v-bind="$attrs" text color="primary" class="ml-2" @click="copy(url)">
      COPY ADDRESS
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "Bookmarklet",
  computed: {
    baseurl() {
      return window.location.protocol + "//" + window.location.host;
    },
    url() {
      // prettier-ignore
      return `javascript:function PopupCenter(url, title, w, h) {var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;var left = ((width / 2) - (w / 2)) + dualScreenLeft;var top = ((height / 2) - (h / 2)) + dualScreenTop;var newWindow = window.open(url, title, "status=no,directories=no,location=no,resizable=no,menubar=no,toolbar=no, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);if (window.focus) {newWindow.focus();}} PopupCenter("${this.baseurl}/bookmarks/0?bookmarkleturl="+encodeURIComponent(window.location.href),"BookmarkExpertSavePopup","520","600");`;
    },
  },
  methods: {
    copy(text) {
      /**
       * there is a bug, when copy button is in a vuetify dialog you
       * need to set a container for the copyText function. Below is
       * a workaround for that.
       */
      // console.log(this.$refs.copy.$el);
      const parentDialog = this.$refs.copy.$el.closest(".v-dialog");
      const container = parentDialog || "undefined";

      this.$copyText(text, container).then(
        (e) => {
          this.$store.commit("updateStateSnackbar", {
            open: true,
            html: "Copied!",
            icon: "success",
            timeout: 2000,
            action: "close",
          });
        },
        (e) => {
          this.$store.commit("updateStateSnackbar", {
            open: true,
            html: "There is a problem!",
            icon: "error",
            timeout: 2000,
            action: "close",
          });
        }
      );
    },
  },
};
</script>
